export const SLICE_NAME = {
    EXAMPLE: 'example',
    HOME: 'home',
    LOGIN: 'login',
    PRODUCT: 'product',
    USER: 'user',
    CART: 'cart',
    ALERT: 'alert',
    LOADER: 'loader',
}